import { render, staticRenderFns } from "./CompanyNews.vue?vue&type=template&id=5395562b&scoped=true&"
import script from "./CompanyNews.vue?vue&type=script&lang=js&"
export * from "./CompanyNews.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNews.vue?vue&type=style&index=0&id=5395562b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395562b",
  null
  
)

export default component.exports